module.exports = __webpack_public_path__ + "static/logo-un-3f94bc35be70429e78e5d5f101a0e997.svg";